import * as integrationsRunsCommands from '@Integrations/Runs/commands-vue-composables'
import * as integrationsRunsQueries from '@Integrations/Runs/queries-vue-composables'
import * as integrationsUsersQueries from '@Integrations/Users/queries-vue-composables'

export function useAdminManageRunsPage(){
	return {
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useRunsOfOrganizationQuery: integrationsRunsQueries.useRunsOfOrganizationQueryV1,
	}
}

export function useAdminRunDetailsPage(){
	return {
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useDeleteRunCommand: integrationsRunsCommands.useDeleteRunCommandV1,
		usePermanentDeleteRunCommand: integrationsRunsCommands.usePermanentDeleteRunCommandV1,
		useRunDetailsQuery: integrationsRunsQueries.useRunDetailsQueryV1,
	}
}

